import { createContainer } from 'react-sweet-state';
import { parseSearchResult } from 'api-ito/ToursApi';
import { TourSearchStore } from "./TourSearchStore";
import { makeSearchId, makeSearchQueryFromURLParams } from './utils';
let g_search_store_hydrated = false;
/**
 * Контейнер выполняющий функцию регидратации хранилища.
 */
const Container = createContainer(TourSearchStore, {
    onInit: () => ({ setState }, { initialState: init }) => {
        if ((init === null || init === void 0 ? void 0 : init.type) == 'search-state' && !g_search_store_hydrated) {
            g_search_store_hydrated = true;
            if (init.searchResult) {
                const searchResult = parseSearchResult(init.searchResult);
                const [searchQuery, page] = makeSearchQueryFromURLParams(new URL(document.documentURI).search);
                const searchId = makeSearchId(searchQuery, page);
                setState({ searchResult, searchQuery, searchId, page, pageCount: searchResult.pageCount });
            }
        }
    },
});
export { Container as TourSearchStoreContainer };
